





define([], function() {
    'use strict';

    return {
        hasProperty: function(obj, prop) {
            return Object.prototype.hasOwnProperty.call(obj, prop);
        },
        isNotNull: function(val) {
            if (val === null) {
                return false;
            }
            return (typeof val === 'function') || (typeof val === 'object');
        }
    };
});



// WEBPACK FOOTER //
// ./display/objectUtils.js